import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearEntityChatFilterAction } from 'store/teamChat/actions';
import { selectPendingEntityChatFilter } from 'store/teamChat/selectors';

// Reference-badge click (DEV-5446) drives the References rail's `activeEntityFilter` state from
// OUTSIDE TeamChatChannel's subtree (a Financial Info / Borrowers row) via this queued Redux
// intent — the counterpart of `useChatEntityAttachment` (TeamChatMessageInput), which seeds the
// composer draft the same way for "Discuss in chat". `requestId` dedupes so the SAME pending
// filter is never re-applied twice, while still allowing a second click of the same entity to
// re-trigger the filter.
const useChatEntityFilter = ({ chatId, onApply }) => {
  const dispatch = useDispatch();
  const pending = useSelector(selectPendingEntityChatFilter);
  const appliedRequestIdRef = useRef(null);

  useEffect(() => {
    if (
      !pending ||
      pending.chatId !== chatId ||
      appliedRequestIdRef.current === pending.requestId
    ) {
      return;
    }

    appliedRequestIdRef.current = pending.requestId;
    onApply({ entityType: pending.entityType, entityId: pending.entityId });
    dispatch(clearEntityChatFilterAction());
  }, [pending, chatId, onApply, dispatch]);
};

export default useChatEntityFilter;
